import React from 'react'
import { FinancingCallbackStatusWrapper } from '../FinancingCallbackStatusWrapper'
import { messages } from './messages'

export const FinancingCallbackError = () => {
  return <FinancingCallbackStatusWrapper icon="red/error" title={messages.title} subtitle={messages.subtitle} />
}
